import { useEffect, useState, React } from "react";
import { BrowserRouter, Route, Routes, Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { useAuthContext } from "../../Hooks/useAuthContext";
import Spinner from "../../Components/Loading/Spinner";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/free-solid-svg-icons'

import FilterBox from "./Components/FilterBox";
import moment from "moment/moment"
export default function ListCustomers() {
    const { dispatch, user } = useAuthContext();
    const navigate = useNavigate();

    const [loading, setLoading] = useState(true);
    const [customers, setCustomers] = useState([]);

    const handleFilter = (form) => {
        loadCustomers(form);
    }

    const loadCustomers = (form) => {
        console.log("loading customers...");

        var code = form ? form.code : "";
        var name = form ? form.name : "";
        var location = form ? form.location : "";
        var dateGreaterThan = form ? form.dateGreaterThan : "";
        var dateLessThan = form ? form.dateLessThan : "";
        var assignedAgentId = form ? form.assignedAgentId : "";

        axios
            .get(`https://${process.env.REACT_APP_IP}/api/customers/?` +
                `code=${code}` +
                `&name=${name}` +
                `&location=${location}` +
                `&dateGreaterThan=${dateGreaterThan}` +
                `&dateLessThan=${dateLessThan}` +
                `&assignedAgentId=${assignedAgentId}`,
                 {
                headers: { Authorization: `bearer ${user.token}` },
            })
            .then((res) => {
                console.log("Users:", res.data);
                setCustomers(res.data);
                setLoading(false);
            })
            .catch((err) => {
                console.log(err);
                setLoading(false);

                if (err.response.status === 401) {
                    dispatch({ type: "LOGOUT" })
                    navigate("../")
                }
            });
    }

    // Load users
    useEffect(() => {
        loadCustomers();
          
    }, []);



    return (
        <div className="page">
            <div className="row">
                <div className="col-12">
                    {loading && (<Spinner />)}
                    {!loading && (
                        <>
                        <h1>Customers <button className="btn-sm btn-primary" onClick={() => { navigate(`/Customers/Create/`) }}><FontAwesomeIcon icon={faPlus} /> Add</button> </h1>

                        <FilterBox filterOrders={handleFilter} />

                        <table style={{width: "100%"}}>
                            <thead>
                                <tr>
                                    <th>Code</th>
                                    <th>Name</th>
                                    <th>Assigned Agent</th>
                                    <th>Location</th>
                                    <th>Last Order</th>
                                    <th>&nbsp;</th>
                                </tr>
                            </thead>
                            <tbody>
                                {customers && (customers.map((customer) => {
                                    return (
                                        <tr key={customer.id} style={{ cursor: "pointer" }}>
                                            <td onClick={() => { navigate(`/Customers/View/${customer.id}`) }}>{customer.code}</td>
                                            <td onClick={() => { navigate(`/Customers/View/${customer.id}`) }}>{customer.name} {customer.farm && `(${customer.farm})`}</td>
                                            <td onClick={() => { navigate(`/Customers/View/${customer.id}`) }}>{customer.assignedAgent && customer.assignedAgent.name}</td>
                                            <td onClick={() => { navigate(`/Customers/View/${customer.id}`) }}>{customer.location}</td>
                                            <td onClick={() => { navigate(`/Customers/View/${customer.id}`) }}>{customer.lastOrderDate && moment(customer.lastOrderDate).format('DD/MM/YYYY')}</td>


                                            <td style={{ width: 130 }}>
                                                <Link to={`/Customers/View/${customer.id}`} className="btn-sm btn-primary">View</Link>
                                                <Link to={`/Customers/Edit/${customer.id}`} className="btn-sm btn-other">Edit</Link>
                                            </td>
                                        </tr>
                                    )
                                }))}
                            
                            </tbody>
                        </table>
                        </>
                    )}
                </div>
            </div>
        </div>
  )
}
